/** @format */

export const ENV_ALGOLIA_CL_INDEX_PURCHASES = process.env.REACT_APP_ALGOLIA_CL_INDEX_PURCHASES
export const ENV_ALGOLIA_FRONT_KEY = process.env.REACT_APP_ALGOLIA_FRONT_KEY
export const ENV_ALGOLIA_ID = process.env.REACT_APP_ALGOLIA_ID
export const ENV_ALGOLIA_KEY = process.env.REACT_APP_ALGOLIA_KEY
export const ENV_ALGOLIA_INDEX_SUBJECT = process.env.REACT_APP_ALGOLIA_INDEX_SUBJECT
export const ENV_BASE = process.env.REACT_APP_BASE
export const ENV_FACEBOOK_LOGIN = process.env.REACT_APP_FACEBOOK_LOGIN
export const ENV_FUNCTION_AGREEMENT = process.env.REACT_APP_FUNCTION_AGREEMENT
export const ENV_FUNCTION_BANNER = process.env.REACT_APP_FUNCTION_BANNER
export const ENV_FUNCTION_BARCODE = process.env.REACT_APP_FUNCTION_BARCODE
export const ENV_FUNCTION_CHECKOUT = process.env.REACT_APP_FUNCTION_CHECKOUT
export const ENV_FUNCTION_CUSTOM_STYLES = process.env.REACT_APP_FUNCTION_CUSTOM_STYLES
export const ENV_FUNCTION_DRUGS = process.env.REACT_APP_FUNCTION_DRUGS
export const ENV_FUNCTION_FRONT_COMMON = process.env.REACT_APP_FUNCTION_FRONT_COMMON
export const ENV_FUNCTION_GENERATE_PHARMACY = process.env.REACT_APP_FUNCTION_GENERATE_PHARMACY
export const ENV_FUNCTION_IMAGE_MANAGEMENT = process.env.REACT_APP_FUNCTION_IMAGE_MANAGEMENT
export const ENV_FUNCTION_MIGRATION_PHAROL = process.env.REACT_APP_FUNCTION_MIGRATION_PHAROL
export const ENV_FUNCTION_MIGRATION_UPLOAD_ALGOLIA = process.env.REACT_APP_FUNCTION_MIGRATION_UPLOAD_ALGOLIA
export const ENV_FUNCTION_NOVEDADES = process.env.REACT_APP_FUNCTION_NOVEDADES
export const ENV_FUNCTION_CLAIM = process.env.REACT_APP_FUNCTION_CLAIM
export const ENV_FUNCTION_PANEL_MENU = process.env.REACT_APP_FUNCTION_PANEL_MENU
export const ENV_FUNCTION_PANEL_TRACKING = process.env.REACT_APP_FUNCTION_PANEL_TRACKING
export const ENV_FUNCTION_PHARMACY_LETTERS = process.env.REACT_APP_FUNCTION_PHARMACY_LETTERS
export const ENV_FUNCTION_PRODUCTS = process.env.REACT_APP_FUNCTION_PRODUCTS
export const ENV_FUNCTION_PROMOTION = process.env.REACT_APP_FUNCTION_PROMOTION
export const ENV_FUNCTION_PUNTO_PAGO = process.env.REACT_APP_FUNCTION_PUNTO_PAGO
export const ENV_FUNCTION_QUOTATION = process.env.REACT_APP_FUNCTION_QUOTATION
export const ENV_FUNCTION_RESERVE = process.env.REACT_APP_FUNCTION_RESERVE
export const ENV_FUNCTION_SCHEDULE = process.env.REACT_APP_FUNCTION_SCHEDULE
export const ENV_FUNCTION_SERVICES = process.env.REACT_APP_FUNCTION_SERVICES
export const ENV_FUNCTION_SUCCESS_TRANSACTION = process.env.REACT_APP_FUNCTION_SUCCESS_TRANSACTION
export const ENV_FUNCTION_UPLOAD_PHARMACY = process.env.REACT_APP_FUNCTION_UPLOAD_PHARMACY
export const ENV_FUNCTION_USER = process.env.REACT_APP_FUNCTION_USER
export const ENV_GENERAL_STORAGE_IMAGES = process.env.REACT_APP_GENERAL_STORAGE_IMAGES
export const ENV_MARKETPLACE_CONFIGURATION = process.env.REACT_APP_FUNCTION_MARKETPLACE_CONFIGURATION
export const ENV_GOOGLE_LOGIN = process.env.REACT_APP_GOOGLE_LOGIN
export const ENV_IMAGE_ROUTE = process.env.REACT_APP_IMAGE_ROUTE
export const ENV_SERVICE_DRUGS = process.env.REACT_APP_SERVICE_DRUGS
export const ENV_NOTIFICATION_PUSH = process.env.REACT_APP_FUNCTION_NOTIFICATION_PUSH
export const ENV_BASE_BACKEND = process.env.REACT_APP_BASE_BACKEND
export const ENV_CONVERT_INTERFACE_FILE = process.env.REACT_APP_FUNCTION_CONVERT_INTERFACE_FILE
export const ENV_BASE_MERCADO_PAGO_AR = process.env.REACT_APP_FUNCTION_MERCADO_PAGO_AR
export const ENV_COUNTRY = process.env.REACT_APP___COUNTRY
